export default __webpack_public_path__ + "static/media/new client.5bf21723.svg";